import { ROUTES, ROLES } from 'config/constants';

export function getUserRoleByGroups(groups) {
  let userRole = ROLES.REPRESENTATIVE;

  (groups ?? []).forEach((group) => {
    switch (group) {
      case ROLES.RESEARCH_SITE:
        userRole = group;
        break;
      case ROLES.PERSONNEL:
        userRole = group;
        break;
      case ROLES.SPONSOR:
        userRole = group;
        break;
      default:
    }
  });

  return userRole;
}

export function getUserProfileUrlByRole(
  userRole,
  userId,
  tail = '/organization',
) {
  let url;
  switch (userRole) {
    case ROLES.RESEARCH_SITE:
      url = `${ROUTES.USER_PROFILE}${ROUTES.RESEARCH_SITES}/${userId}${tail}`;
      break;
    case ROLES.INACTIVE_RESEARCH_SITE:
      url = `${ROUTES.USER_PROFILE}${ROUTES.INACTIVE_RESEARCH_SITE}/${userId}`;
      break;
    case ROLES.PERSONNEL:
    case ROLES.PERSONNEL_INACTIVE:
      url = `${ROUTES.USER_PROFILE}${ROUTES.ALL_PERSONNEL}/${userId}/academic-qualification`;
      break;
    case ROLES.INACTIVE_SPONSOR:
      url = `${ROUTES.USER_PROFILE}${ROUTES.INACTIVE_SPONSORS}/${userId}`;
      break;
    case ROLES.SPONSOR:
    default:
      url = `${ROUTES.USER_PROFILE}${ROUTES.SPONSORS}/${userId}${tail}`;
      break;
  }

  return url;
}

export function getUserProfileUrlByGroups(userGroups, userId) {
  const userRole = getUserRoleByGroups(userGroups);

  return getUserProfileUrlByRole(userRole, userId);
}

export function getUserRoleLabel(role) {
  switch (role) {
    case ROLES.SPONSOR:
    case ROLES.INACTIVE_SPONSOR:
      return 'Sponsor';
    case ROLES.RESEARCH_SITE:
    case ROLES.INACTIVE_RESEARCH_SITE:
      return 'Research site';
    case ROLES.PERSONNEL:
      return 'Personnel';
    default:
      return 'Unknown role';
  }
}
